import React from "react";
import "../style/LoadingScreen.scss"; // Import SCSS file


const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <img 
          src="/logo/logo evas avec le nom.png" 
          alt="Your Logo" 
          className="loading-logo"
        />
        <div className="loading-spinner">
          <div className="spinner-circle"></div>
          <div className="spinner-circle"></div>
          <div className="spinner-circle"></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;